<template>
	<div>
		<div class="container">
			<div class="page page-products">
				<div v-if="isLoading && !product && !isProductPrivate" class="container-fliud box">
					<div class="row border-bottom">
						<div class="px-4 mb-3">
							<!-- breadcrumb -->
							<shimmer
								width="150px"
								height="24px"
							/>
						</div>
					</div>
					<div class="row pt-4">
						<div :class="'col-md-5'" class="p-0" ref="photoElement">
							<div class="px-4">
								<!-- main image -->
								<shimmer
									width="100%"
									height="300px"
								/>
							</div>
							<div class="px-4">
								<div class="row my-2">
									<div class="col" v-for="i in 5" :key="i">
										<!-- other images -->
										<shimmer
											width="100%"
											height="73px"
										/>
									</div>
								</div>
							</div>
							<div class="px-4">
								<shimmer
									width="60%"
									height="73px"
								/>
							</div>
						</div>
						<div :class="'col-md-7'" class="details">
							<!-- product title -->
							<shimmer
								width="100%"
								height="35px"
								class="mb-2"
							/>

							<!-- product aggregate -->
							<shimmer
								width="50%"
								height="18px"
							/>

							<!-- pricing -->
							<shimmer
								width="240px"
								height="30px"
								class="mt-4"
							/>

							<!-- button jual sekarang -->
							<shimmer
								width="124px"
								height="37px"
								class="mt-4"
							/>

							<!-- variant tersedia -->
							<shimmer
								width="124px"
								height="24px"
								class="mt-4"
							/>

							<!-- keterangan -->
							<shimmer
								width="100px"
								height="66px"
								class="mt-3"
							/>

							<!-- table variant -->
							<shimmer
								width="80%"
								height="300px"
								class="mt-2"
							/>

							<!-- nav tab -->
							<shimmer
								width="150px"
								height="40px"
								class="mt-3"
							/>

							<!-- description -->
							<shimmer
								width="100%"
								height="300px"
								class="mt-2"
							/>
						</div>
					</div>
				</div>
				<div class="not-found text-center pt-4" v-else-if="!isLoading && !product && !isProductPrivate">
					<img src="/img/not_found.png" :width="250" alt="">
					<h3>Oops. . . Produk tidak ditemukan!</h3>
					<button
						class="btn btn-primary"
						@click.prevent="back()"
					>{{ $t('Kembali') }}</button>
				</div>
				<div v-else-if="!isLoading && product && !isProductPrivate" class="container-fliud box position-relative">
					<div class="row border-bottom" :class="{ 'blur' : isProductPrivate }">
						<div class="px-4 mb-3">
							<breadcrumb :paths="setBreadcrumb"></breadcrumb>
						</div>
					</div>
					<div class="row pt-4" :class="{ 'blur' : isProductPrivate }">
						<div class="col-md-5 p-0" ref="photoElement">
							<div class="px-4">
								<VueSlickCarousel
									ref="carouselmain"
									v-bind="carouselMain"
									@beforeChange="onBeforeChangeMain"
									class="sds"
								>
									<div v-for="(picture, index) in product.pictures" :key="index">
										<img :src="picture" class="img-main" />
									</div>
									<div v-if="(youtubeThumb(videos[0]) != '')" :key="getIndexOfVideo">
										<img :src="youtubeThumb(videos[0])" class="img-main" />
									</div>
								</VueSlickCarousel>
							</div>
							<div class="px-4">
								<VueSlickCarousel
									ref="carouselthumb"
									v-bind="carouselControl"
									@beforeChange="onBeforeChangeThumb"
								>
									<div class="img-thumb-box" v-for="(picture, index) in product.pictures" :key="index">
										<img :src="picture" class="img-thumb" />
									</div>
									<div class="img-thumb-box" v-if="(youtubeThumb(videos[0]) != '')" :key="getIndexOfVideo">
										<img :src="youtubeThumb(videos[0])" class="img-thumb" @click="showVideo(true)" />
									</div>
								</VueSlickCarousel>
							</div>
							<supplier-card
								v-if="!isAdmin"
								:supplier-code="supplierCode"
								:supplier-origin="supplierOrigin"
								:store-availability="storeAvailability"
							/>
						</div>
						<div :class="'col-md-7'" class="details">
							<h3 class="product-title" ref="productTitle">{{ product.name }}</h3>
							<div class="product-aggregate d-flex" ref="productAggregate">
								<li class="mr-3 first-aggregate">Rekomendasi Harga Jual <span>{{ sellPrice }}</span></li>
								<li class="mr-3">Berat <span>{{ weight }}gr</span></li>
								<li class="mr-3">Stok <span>{{ getStockQuantity(product) }}</span></li>
								<li class="mr-3">Dikirim dari <span>{{ getShippingOrigin(product) }}</span></li>
							</div>
							<badges class="mt-1" :is-cod-enabled="isCODEnabled" :is-lp-enabled="isLpEnabled" :is-marketing-kit-enabled="isMarketingKitEnabled" :is-private-enabled="product.visibility && product.visibility === 'private'"></badges>
							<div class="pricing mt-4" ref="pricing">
								<!-- Buy Price without sale price -->
								<!-- <div class="selling-price">
									<h4>
										<span class="text-black">Harga Modal :</span>
										<router-link to="/login" class="text-decoration-none" v-if="!user">
											<span class="price-color" v-tooltip="'Untuk melihat Harga Modal dapat Login/Daftar disini'">
												{{ buyPrice }}
											</span>
											<p class="price-mobile mt-3">
												<span class="price-info">Untuk melihat Harga Modal dapat </span> Login/Daftar disini
											</p>
										</router-link>
										<span v-else>
											{{ buyPrice }}
										</span>
									</h4>
								</div> -->

								<!-- Buy Price with sale price -->
								<div class="selling-price">
									<h4 class="d-flex align-items-center">
										<!-- User is not logged in -->
										<router-link
											to="/login"
											class="text-decoration-none"
											v-tooltip="'Untuk melihat Harga Modal dapat Login/Daftar disini'"
											v-if="!user"
										>
											<div class="text-black">Harga Modal :</div>
											<div class="price-color">{{ originalBuyPrice }}</div>
											<div class="d-flex align-items-center">
												<span class="sale-price">{{ buyPrice }}</span>
												<span
													class="badge badge-danger ml-1 percent-off"
												>
													{{ percentOff }}
												</span>
											</div>
											<p class="price-mobile mt-3">
												<span class="price-info">Untuk melihat Harga Modal dapat </span> Login/Daftar disini
											</p>
										</router-link>

										<!-- User is logged in -->
										<div v-else>
											<div class="text-black">Harga Modal :</div>
											<div class="price-color">{{ originalBuyPrice }}</div>
											<div class="d-flex align-items-center">
												<span
													class="sale-price"
													:class="{ 'invisible': !hasSalePrice }"
												>
													{{ buyPrice }}
												</span>
												<span
													class="badge badge-danger ml-1 percent-off"
													v-if="percentOff !== '-' && percentOff !== '0%'"
												>
													{{ percentOff }}
												</span>
											</div>
										</div>
									</h4>
								</div>
								<button
									v-if="!isAdmin"
									class="btn btn-primary mb-3"
									:class="{ 'is-loading': isAddingProduct }"
									@click.prevent="onClickAddProduct()"
									:disabled="isDisabled"
								>
									<span v-if="isProductAdded">
										✓ {{ $t('Ditambahkan') }}
									</span>
									<span v-else>
										<span v-if="isProductPrivate">
											{{ $t('Private') }}
										</span>
										<span v-else>
											{{ $t('Jual Sekarang') }}
										</span>
									</span>
								</button>
								<button
									class="btn outline-primary ml-2 mb-3" @click="addToWishlist" v-if="user && !isAdmin">
									<span :class="{ 'is-loading': isAddingWishlist }">
										<i class="bi bi-heart-fill text-danger" v-if="isProductWishlisted" :style="favoriteIconStyle"></i>
										<i class="bi bi-heart" v-else :style="favoriteIconStyle"></i>
										<span>Wishlist</span>
									</span>
								</button>
								<button class="btn outline-primary ml-2 share-btn mb-3" @click="showShare">
									<i class="bi bi-share-fill"></i>
									<span>Share</span>
								</button>
								<button
									v-if="!isAdmin && user"
									class="btn outline-danger ml-2 ask-btn mb-3" @click="askStock"
									:class="{'is-loading': isAskingStock}">
									<i class="bi bi-chat-left-text"></i>
									<span>Tanyakan Stok</span>
								</button>
							</div>

							<div class="product-variations mt-4" v-if="product && product.type == 'variable' && productVariations && productVariations.prices && productVariations.prices.length > 0">
								<p class="title mb-1 text-bold">
									Variant tersedia :
								</p>
								<div class="desc">
									<label><strong>Keterangan :</strong></label>
									<div class="capital-price" for="HM"><strong>HM :</strong> Harga Modal</div>
									<div class="selling-price" for="HJ"><strong>HJ :</strong> Rekomendasi Harga Jual</div>
								</div>
								<div class="row table-responsive">
									<table
										:class="{
											'col-lg-3': productVariations.table.field.length == 1 && productVariations.table.type == 'single',
											'col-lg-4': productVariations.table.field.length == 1 && productVariations.table.type !== 'single',
											'col-lg-6': productVariations.table.field.length == 2 && productVariations.table.type == 'single',
											'col-lg-7': productVariations.table.field.length == 2 && productVariations.table.type !== 'single',
											'col-lg-9': productVariations.table.field.length > 2
										}"
										class="variant-table table table-striped table-hover mt-2"
									>
										<thead>
											<tr>
												<th v-if="productVariations.table.type !== 'single'"></th>
												<th v-for="(item, idx) in productVariations.table.field" :key="idx" :class="{ 'hidden': isAllColumnNull(item) }">
													{{ item }}
												</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(items, index) in tableData" :key="index" :class="{ 'hidden': isAllRowNull(index) }">
												<td v-if="productVariations.table.type !== 'single'" class="text-center align-middle multiple-variant">
													<strong>{{index}}</strong>
												</td>
												<td v-for="(price, key, idx) in items" :key="idx" :class="{ 'hidden': isAllDataNull(key) }">
													<div :class="{ 'invisible': !isVariationEnabled(index, key) }">
														<div>
															<span>HM : </span>
															<span v-if="!isVariationEnabled(index, key)">-</span>
															<span v-else>{{ getBuyPrice(price, getOutsourceCommissionVariation(index, key), false) }}</span> <!-- Buy Price Without Commission -->
															<!-- <span v-else>{{ getBuyPrice(price, getOutsourceCommissionVariation(index, key)) }}</span> --> <!-- Buy Price With Commission -->
														</div>
														<div>
															<span>HJ : </span>
															<span v-if="!isVariationEnabled(index, key)">-</span>
															<span v-else>{{ getSellPrice(price, getMarginVariation(index, key), getOutsourceCommissionVariation(index, key), false) }}</span>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>

							<!-- <div class="benefit-for-seller mt-4">
								<div class="d-flex justify-content-between">
									<h5>Benefit For Seller</h5>
									<div v-if="carouselBenefit.slidesToShow < benefits.length">
										<i class="bi bi-arrow-left-circle mr-1" style="cursor: pointer;" @click="showNext('carouselbenefit')"></i>
										<i class="bi bi-arrow-right-circle ml-1" style="cursor: pointer;" @click="showPrev('carouselbenefit')"></i>
									</div>
								</div>
								<VueSlickCarousel
									ref="carouselbenefit"
									v-bind="carouselBenefit"
								>
									<div v-for="(item, index) in benefits" :key="index">
										<div class="benefit-icon text-center">
											<img :src="'/img/'+item.imgName" class="img-center" alt="benefit-img">
										</div>
										<div class="benefit-name text-center">{{item.name}}</div>
									</div>
								</VueSlickCarousel>
							</div> -->

							<div class="mt-4">
								<hr class="m-0">
								<nav ref="nav">
									<div class="nav nav-tabs" id="nav-tab" role="tablist">
										<a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#detailTab" @click="assignActiveTab('detailTab')" role="tab" aria-controls="nav-home" aria-selected="true">Detail</a>
										<a v-if="isShowMarketingKit || isShowMarketingKits" class="nav-item nav-link" id="nav-home-tab" data-toggle="tab" href="#merketingTab" @click="assignActiveTab('merketingTab')" role="tab" aria-controls="nav-home" aria-selected="true">Marketing Kit</a>
										<a v-if="isHasPage" class="nav-item nav-link" id="nav-home-tab" data-toggle="tab" href="#previewTab" role="tab" @click="assignActiveTab('previewTab')" aria-controls="nav-home" aria-selected="true">Preview Landing Page</a>
									</div>
								</nav>
								<div class="tab-content" id="nav-tabContent">
									<div class="tab-pane fade show active py-4" id="detailTab" role="tabpanel" aria-labelledby="nav-home-tab">
										<div v-if="showDescription && !isDescriptionExpanded" class="overflow-hidden" :style="{maxHeight: scrollAreaMaxHeight}" v-html="this.sanitizeHtml(product.description)"></div>
										<div v-else-if="showDescription && isDescriptionExpanded" v-html="this.sanitizeHtml(product.description)"></div>
									</div>
									<div v-if="isShowMarketingKit || isShowMarketingKits" class="tab-pane fade show py-4" id="merketingTab" role="tabpanel" aria-labelledby="nav-home-tab">
										<!-- <div>
											<span style="white-space: pre;" v-html="this.sanitizeHtml(product.marketing_kit.description)"></span>
											<a target="_blank" :href="product.marketing_kit.link" class="mr-2"><strong>Download</strong> </a>
										</div> -->
										<div class="multi" v-if="isShowMarketingKits">
											<div v-for="item in product.marketing_kit" :key="item.content_code">
												<p v-html="sanitizeHtml(item.description)" ref="description"></p>
												<button class="btn btn-sm btn-primary" target="_blank" @click="downloadMarketingKit(item.content_code)"><strong>Download</strong> </button>
											</div>
										</div>
										<div class="single" v-else>
											<span style="white-space: pre;" v-html="this.sanitizeHtml(product.marketing_kit.description)"></span>
											<a target="_blank" :href="product.marketing_kit.link" class="mr-2"><strong>Download</strong> </a>
										</div>
									</div>
									<div v-if="isHasPage" class="tab-pane fade show py-4" id="previewTab" role="tabpanel" aria-labelledby="nav-home-tab">
										<div v-for="(page, index) in product.pages" :key="index">
											<div class="d-flex justify-content-between mb-3">
												<a target="_blank" :href="page.url" class="mr-2"><strong>{{ page.type.label }}</strong> </a>
												<a target="_blank" :href="page.url" class="btn btn-primary btn-detail">
													<div v-if="page.type.value === 'orderonline'">
														<i class="material-icons">content_copy</i>
														Duplicate
													</div>
													<div v-else>
														<i class="material-icons">download</i>
														Download
													</div>
												</a>
											</div>

											<div class="d-flex justify-content-end" v-for="(preview, i) in page.previews" :key="i">
												<a target="_blank" :href="preview.url">
													<span class="link-preview d-flex align-items-center">
														{{ preview.title }} <i class="ml-1 material-icons link-preview">launch</i>
													</span>
												</a>
											</div>
										</div>
									</div>
								</div>
								<transition name="fade">
									<span class="text-primary description-toggle" v-if="product.description && isDetailTabActive" @click="toggleDescription">{{ toggleDescriptionLabel }}</span>
								</transition>
								<hr>
							</div>
						</div>
					</div>
					<overlay v-if="isProductPrivate">
						Private
					</overlay>
				</div>
				<div class="not-found text-center pt-4" v-else-if="!isLoading && product && isProductPrivate">
					<img src="/img/not_found.png" :width="250" alt="">
					<h3>Oops. . . Anda tidak bisa mengakses produk ini!</h3>
					<button
						class="btn btn-primary"
						@click.prevent="back()"
					>{{ $t('Kembali') }}</button>
				</div>
			</div>

			<!-- Produk Lainnya -->
			<div class="spacer" v-if="featuredConfig.length > 0 && !isLoading && product && !isProductPrivate && !isAdmin">
				<Featured :config="featuredConfig" :meta="featuredMeta" :slug="featuredSlug" />
			</div>

			<div class="modals">
				<modal v-if="(showVideoModal === true)" class="product-dropship-modal" size="large" @close="$emit('close')">
					<div slot="body">
						<div class="container-fliud">
							<div class="wrapper row mt-4">
								<div class="col-md-12">
									<h4 class="product-title">{{ product.name }}</h4>
								</div>
								<div class="col-md-12">
									<div class="embed-responsive embed-responsive-16by9">
										<iframe class="embed-responsive-item" :src="videoEmbedUrl(videos[0])" allowfullscreen></iframe>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div slot="footer">
						<button type="button" class="btn btn-light" @click="showVideo(false)">
							{{ $t('_.close') }}
						</button>
					</div>
				</modal>
			</div>
		</div>
		<main-footer  v-if="!isAdmin" />
		<div class="modals">
			<modal v-if="isShowShare" class="product-dropship-modal" size="large" @close="isShowShare = false">
				<div slot="header">
					<h3>Bagikan Link Product</h3>
				</div>
				<div slot="body">
					<div class="container">
						<div class="card p-3">
							<div class="row">
								<div class="col-md-3">
									<img :src="this.product.picture" width="88" height="88px">
								</div>
								<div class="col-md-9">
									<div class="title-link">
										{{ this.product.name }}
									</div>
									<div class="share-link">
										<i class="bi bi-link-45deg"></i> {{ getFullUrl() }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="container">
						<div class="row">
							<div class="col-md-12 text-center mt-3">
								<div class="share-info">
									Mau Bagikan Kemana?
								</div>
								<div class="btn btn-sm btn-share">
									<div class="btn btn-sm btn-share icon" @click="shareWhatsapp()">
										<i class="bi bi-whatsapp d-block text-success"></i>
									</div>
									<div class="mt-2">
										Whatsapp
									</div>
								</div>
								<div class="btn btn-sm btn-share">
									<div class="icon" @click="copyLink()">
										<i class="bi bi-link-45deg d-block"></i>
									</div>
									<div class="mt-2">
										Salin Link
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer">
					<button type="button" class="btn btn-light" @click="isShowShare = false">
						{{ $t('_.close') }}
					</button>
				</div>
			</modal>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import Featured from '@/components/homepages/sections/Featured.vue';
import Overlay from '@/components/homepages/sections/partials/Overlay.vue';
import {
	// getCommissionValue,
	elipsisPrice,
	getMarginValue,
} from '@/lib/product';
import {
	formatMoney,
	getYoutubeThumb,
	getYoutubeId,
	getDropshipFinalPrice,
	getProductPricePlusCommission,
	getSimpleProductOriginalPrice,
	calculateDiscount,
	getDropshipVariationFinalPrice,
	getAxiosErrorMessage,
	isHasFeature,
	getIsDiscounted,
	getSalePrice,
	getWholesalePrice,
	// getOstockCommissionValue,
	getShippingOrigin,
	getShippingCityProvince,
	duplicateVar,
	// isPrivate,
	copyToClipboard,
	sanitizeHtml,
	getVariableCommisionValue,
} from '@/lib/helper';
import Modal from '@/components/Modal.vue';
import productApi from '@/api/products';
import dropshipApi from '@/api/dropship';
import Breadcrumb from '@/components/Breadcrumb.vue';
import MainFooter from '@/components/homepages/Footer.vue';
import Shimmer from '@/components/Shimmer.vue';
import Badges from '@/components/products/Badges.vue';
import SupplierCard from '@/components/SupplierCard.vue';
import orderonlineApi from '@/api/orderonline';
import wishlistApi from '@/api/wishlist';
import homepageApi from '@/api/homepage';

export default {
	name: 'HomepageProductDetail',
	components: {
		Modal,
		VueSlickCarousel,
		Breadcrumb,
		Featured,
		MainFooter,
		Shimmer,
		Overlay,
		Badges,
		SupplierCard,
	},
	data() {
		return {
			isLoading: false,
			isDuplicating: false,
			productSlug: this.$route.params?.slug ?? null,
			carouselMain: {
				arrows: false,
				asNavFor: this.$refs.carouselthumb,
				focusOnSelect: true,
			},
			carouselControl: {
				arrows: true,
				asNavFor: this.$refs.carouselmain,
				slidesToShow: 5,
				focusOnSelect: true,
			},
			carouselBenefit: {
				arrows: false,
				asNavFor: this.$refs.carouselbenefit,
				slidesToShow: 5,
				focusOnSelect: true,
			},
			videos: this.product?.videos || [''],
			showVideoModal: false,
			product: null,
			benefits: [
				{
					id: 1,
					name: 'Potensi Margin Tinggi',
					imgName: 'benefit-high-margin.svg',
				}, {
					id: 2,
					name: 'Langsung Dari Tangan Pertama',
					imgName: 'benefit-first-hand.svg',
				}, {
					id: 3,
					name: 'Stok Aman',
					imgName: 'benefit-stock.svg',
				}, {
					id: 4,
					name: 'Terjual Ribuan PCS',
					imgName: 'benefit-sold.svg',
				}, {
					id: 5,
					name: 'Banyak Testimoni Dari Pembeli',
					imgName: 'benefit-testimony.svg',
				}, {
					id: 6,
					name: 'Bisa COD',
					imgName: 'benefit-cod.svg',
				},
			],
			isAddingProduct: false,
			ooProduct: null,
			featuredConfig: [],
			featuredSlug: 'other-products',
			featuredMeta: {
				title: 'Produk Lainnya',
				icon: 'bi-tags',
			},
			elementHeight: {
				photoElement: 0,
				productTitle: 0,
				productAggregate: 0,
				pricing: 0,
				nav: 0,
				padding: 24 + 24, // detail tab padding top & bottom
				margin: 24 + 12 + 64, // pricing margin top, another margin/padding, read more span
			},
			showDescription: false,
			isDescriptionExpanded: false,
			activeTab: 'detailTab',
			isAddingWishlist: false,
			isShowShare: false,
			isAskingStock: false,
			isHidden: false,
		};
	},
	methods: {
		...mapActions({
			getDropshipProductAdded: 'homepage/getDropshipProductAdded',
			appendProductAdded: 'homepage/appendProductAdded',
			funnelDuplicate: 'homepage/funnelDuplicate',
			getProductWishlistAdded: 'wishlist/getProductWishlistAdded',
			appendWishlistAdded: 'wishlist/appendWishlistAdded',
			removeWishlistAdded: 'wishlist/removeWishlistAdded',
		}),
		getCurrentRoute() {
			let currentRoute = this.$route.path;
			if (this.isAdmin) {
				currentRoute = currentRoute.replace('/admin', '');
				currentRoute = currentRoute.replace('/products', '/product');
				currentRoute = currentRoute.replace('/preview', '');
			}

			return currentRoute;
		},
		copyToClipboard,
		copyLink() {
			copyToClipboard(this.getFullUrl());
			this.$notify({
				group: 'app',
				title: 'Berhasil Salin Link',
				text: 'Link Produk berhasil disalin',
				type: 'success',
			});
		},
		shareWhatsapp() {
			const fullUrl = this.getFullUrl();
			const name = this.product.name;
			const text = encodeURIComponent(`${name},Check out this link: ${fullUrl}`);

			const whatsappLink = `https://api.whatsapp.com/send?text=${text}`;

			window.open(whatsappLink, '_blank');
		},
		askStock() {
			const text = encodeURIComponent(`Halo Ostock, Apakah Produk ${this.product.name} ini Ready Stok? ${this.getFullUrl()}`);
			const phone = '6281312649796';

			const whatsappLink = `https://api.whatsapp.com/send?text=${text}&phone=${phone}`;

			const params = this.fetchParamAskStock();

			this.isAskingStock = true;

			const callback = () => {
				this.isAskingStock = false;
				window.open(whatsappLink, '_blank');
			};

			const errorCallback = () => {
				this.isAskingStock = false;
			};

			homepageApi.askStock(params, callback, errorCallback);
		},
		fetchParamAskStock() {
			const params = {};
			params.supplier_id = this.product?.user._id?.$oid;
			params.product_id = this.product?._id?.$oid;
			params.product_name = this.product?.name;

			return params;
		},
		getFullUrl() {
			return window.location.origin + this.getCurrentRoute();
		},
		showShare() {
			this.isShowShare = true;
		},
		back() {
			this.$router.go(-1);
		},
		getStockQuantity(product) {
			const isSimple = product.type === 'simple';
			const quantity = isSimple ? product.stock.quantity : product.variations.prices.reduce((prevQty, variation) => {
				const variationQuantity = variation.stock ? variation.stock.quantity : 0;
				const totalQuantity = prevQty + variationQuantity;
				return totalQuantity;
			}, 0);

			return quantity;
		},
		youtubeThumb(url) {
			const vidUrl = url || '';
			return getYoutubeThumb(vidUrl);
		},
		showVideo(state) {
			this.showVideoModal = state;
		},
		videoEmbedUrl(videoUrl) {
			const videoId = getYoutubeId(videoUrl);
			return `https://www.youtube.com/embed/${videoId}`;
		},
		onBeforeChangeThumb(currentPosition, nextPosition) {
			this.$refs.carouselmain.goTo(nextPosition);
		},
		onBeforeChangeMain(currentPosition, nextPosition) {
			this.$refs.carouselthumb.goTo(nextPosition);
		},
		assignProductTitle(product) {
			document.title = `Product Detail | ${product.name} | ${product._id.$oid} | Ostock`;
		},
		getProductBySlug(slugName) {
			this.isLoading = true;
			const params = {
				limit: 1,
				page: 1,
				slug: slugName,
			};
			let visibility = this.$route.query?.visibility;

			if (this.user?.role !== 'owner') {
				visibility = 'all';
			}
			if (visibility) {
				params.visibility = visibility;
			}
			if (this.user) {
				params.user_id = this.user?._id?.$oid ?? this.user?._id;
			}

			const cb = (resp) => {
				this.isLoading = false;
				this.product = resp.data ? resp.data.products[0] : null;
				this.featuredConfig = [];
				this.featuredConfig.push(this.product);
				if (this.product) {
					this.assignProductTitle(this.product);
				}
			};
			const errorCb = () => {
				this.isLoading = false;
				this.$notify({
					group: 'products',
					text: 'Product Not found',
					type: 'error',
				});
			};
			productApi.getPublicProducts(params, cb, errorCb);
		},
		checkProductPrivate(productId) {
			this.isLoading = true;

			const params = {
				product_id: productId,
			};

			if (this.user) {
				const userId = this.user?.parent_id ?? this.user?._id;

				params.user_id = userId;
			}

			const cb = (resp) => {
				this.isLoading = false;
				this.isHidden = resp.data ?? false;
			};

			const errorCb = () => {
				this.isLoading = false;
			};

			productApi.checkPrivate(params, cb, errorCb);
		},
		onClickAddProduct() {
			if (!this.user) {
				this.$router.push({ path: '/login' });
			} else if (!this.isOoLoggedIn) {
				this.$router.push({ path: '/settings/connections', query: { msg: 'oo_account' } });
			} else {
				this.sellProduct(this.product);
			}
		},
		sellProduct(product) {
			// sell product oo - DEPCRECATED METHOD
			// this.sellProductOO(product, bulk);
			// duplicate LP - DEPCRECATED METHOD
			// this.duplicateFunnel(product);

			this.addProductToOO(product);
		},
		addProductToOO(product) {
			this.isAddingProduct = true;

			let productId = product._id;
			if (typeof product._id === 'object') {
				productId = product._id.$oid;
			}

			const params = {
				product_id: productId,
				duplicate_funnel: false,
			};

			const callback = (response) => {
				const addedProduct = response.data.added;
				this.appendProductAdded(addedProduct);
				this.funnelDuplicate(addedProduct);

				this.$notify({
					group: 'dropship',
					title: 'Dropship',
					text: `Berhasil menambah produk ${product.name}`,
					type: 'success',
				});

				this.isAddingProduct = false;
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'dropship',
					title: 'Dropship',
					text: message,
					type: 'error',
				});
				this.isAddingProduct = false;
			};

			orderonlineApi.addDropshipProduct(params, callback, errorCallback);
		},
		sellProductOO(product, bulk = false) {
			this.isAddingProduct = true;
			product.dropship.original_price = product.price;
			const params = {
				name: product.name,
				autoresponders: JSON.stringify(product.autoresponders),
				bump: JSON.stringify(product.bump),
				category: JSON.stringify(product.category),
				code: product.code,
				collections: JSON.stringify(product.collections),
				description: product.description,
				form: JSON.stringify(product.form),
				pictures: JSON.stringify(product.pictures),
				slug: product.slug,
				type: product.type,
				price: getDropshipFinalPrice(product, [], 1, !this.isOfficialSeller), // normal seller(hpp + komisi + margin) x official seller(hpp + komisi)
				sale_price: JSON.stringify(product.sale_price),
				weight: product.weight,
				shipping: JSON.stringify(product.shipping),
				dropship: JSON.stringify(product.dropship),
				variations: JSON.stringify(getDropshipVariationFinalPrice(product, this.isOfficialSeller, !this.isOfficialSeller)), // normal seller(hpp + komisi + margin) x official seller(hpp + komisi)
				is_deleted: product.is_deleted,
				is_public: this.isOfficialSeller,
				max_quantity: JSON.stringify(product.max_quantity),
				notifications: JSON.stringify([]),
				order_distribution: JSON.stringify(product.order_distribution),
				payment_channels: JSON.stringify(product.payment_channels),
				payment_channels_descriptions: JSON.stringify(
					product.payment_channels_descriptions,
				),
				payment_methods_descriptions: JSON.stringify(
					product.payment_methods_descriptions,
				),
				payments: JSON.stringify(product.payments),
				status: product.status,
				stock: JSON.stringify(product.stock),
				unique_code_price: JSON.stringify(product.unique_code_price),
				wholesale: JSON.stringify(this.getWholesale(product)),
				facebook_custom_audiences: JSON.stringify(
					product.facebook_custom_audiences,
				),
				source_id: product._id.$oid,
				source_type: 'ostock',
				source_user_id: product.user._id.$oid,
				pages: JSON.stringify(product.pages),
				videos: JSON.stringify(product.videos),
				commission_percentage: product.commission_percentage,
			};
			if (product.outsource_commission) {
				params.outsource_commission = JSON.stringify(product.outsource_commission);
			}
			const callback = (res) => {
				const OoProduct = res.data;
				this.ooProduct = OoProduct;
				this.getDropshipProductAdded();

				this.isAddingProduct = false;
				this.addProduct(product._id.$oid, {
					price: getDropshipFinalPrice(product, [], 1, !this.isOfficialSeller),
					source_type: 'orderonline',
					reference_id: OoProduct._id,
				});
				if (!bulk) {
					this.$notify({
						group: 'dropship',
						title: 'Dropship',
						text: `Berhasil menambah produk ${product.name}`,
						type: 'success',
					});
				}
			};
			const errorCallback = (e) => {
				this.isAddingProduct = false;
				const message = getAxiosErrorMessage(e);
				if (message || message !== '') {
					this.$notify({
						group: 'dropship',
						title: 'Dropship',
						text: message,
						type: 'error',
					});
				}
			};
			dropshipApi.addDropshipProduct(
				product._id.$oid,
				params,
				callback,
				errorCallback,
			);
		},
		duplicateFunnel(product) {
			const pages = product.pages ? product.pages : [];
			if (pages.length > 0) {
				const pageIds = pages.map(page => page.url.replace('https://app.orderonline.id/funnels/sharer/', ''));

				const params = {
					ids: JSON.stringify(pageIds),
					all_pages: true,
				};
				const callback = (res) => {
					const responseData = res.data;
					if (responseData.new_objects && responseData.new_objects.length > 0) {
						const newFunnelId = responseData?.new_objects[0]?._id ?? null;
						this.updateFunnelProduct(newFunnelId);
					}

					this.isAddingProduct = false;
				};
				const errorCallback = (e) => {
					this.isAddingProduct = false;
					const message = getAxiosErrorMessage(e);
					if (message || message !== '') {
						this.$notify({
							group: 'dropship',
							title:
								'Error duplicate funnel page into your orderonline account',
							text: message,
							type: 'error',
						});
					}
				};
				dropshipApi.duplicateFunnel(params, callback, errorCallback);
			}
		},
		updateFunnelProduct(funnelId) {
			if (funnelId !== null) {
				const productId = this.ooProduct?._id ?? '';
				const params = {
					funnel_id: funnelId,
					product_id: productId,
				};

				const callback = (res) => {
					const responseData = res.data;
					if (responseData.new_objects && responseData.new_objects.length > 0) {
						const newFunnelId = responseData?.new_objects[0]?._id ?? null;
						this.updateFunnelProduct(newFunnelId);
					}
					this.isAddingProduct = false;
				};
				const errorCallback = () => {
					this.isAddingProduct = false;
				};
				dropshipApi.updateProductFunnel(params, callback, errorCallback);
			}
		},
		async addProduct(id, params) {
			await productApi.addDropshipProduct(id, params);
		},
		getWholesale(product) {
			return this.isOfficialSeller ? product.wholesale : [];
		},
		showNext(ref) {
			this.$refs[ref].next();
		},
		showPrev(ref) {
			this.$refs[ref].prev();
		},
		getBuyPrice(price, outsourceCommission, withCommission = true) {
			const productVariant = this.filterById(this.product?.variations?.prices, outsourceCommission?.variant_id);

			let commission = 0;
			if (productVariant && withCommission) {
				commission = getVariableCommisionValue(productVariant[0], this.product);
			}
			const pricePlusCommission = price + commission;
			return this.user ? formatMoney(pricePlusCommission) : elipsisPrice(pricePlusCommission);
		},
		getSellPrice(productPrice, margin = 0, outsourceCommission, withCommission = true) {
			const productVarian = this.filterById(this.product.variations.prices, outsourceCommission.variant_id);
			// const comission = getCommissionValue(productPrice, this.product.commission_percentage);
			let commission = 0;
			if (productVarian.length > 0 && withCommission) {
				commission = getVariableCommisionValue(productVarian[0], this.product);
			}
			if (margin === 0) {
				margin = getMarginValue(productPrice, this.product.dropship.margin, this.product.dropship.type);
			}

			const isOnDiscount = getIsDiscounted(this.product);
			const salePrice = getSalePrice(this.product);
			const wholesales = this.product.wholesale || [];
			const normalPrice = isOnDiscount ? salePrice : productPrice;
			const price = getWholesalePrice(wholesales, 1, normalPrice);

			const finalPrice = price + margin + commission;
			return formatMoney(finalPrice);
		},
		assignScrollAreaSize() {
			setTimeout(() => {
				this.elementHeight.photoElement = this.$refs.photoElement.clientHeight;
				this.elementHeight.productTitle = this.$refs.productTitle.offsetHeight;
				this.elementHeight.productAggregate = this.$refs.productAggregate.offsetHeight;
				this.elementHeight.pricing = this.$refs.pricing.offsetHeight;
				this.elementHeight.nav = this.$refs.nav.offsetHeight;

				this.showDescription = true;
			}, 1000);
		},
		toggleDescription() {
			this.isDescriptionExpanded = !this.isDescriptionExpanded;
		},
		assignActiveTab(tab) {
			this.activeTab = tab;
		},
		getShippingOrigin,
		getShippingCityProvince,
		getMarginVariation(key1, key2) {
			let marginValue = 0;
			if (this.productVariations?.table?.margin) {
				marginValue = this.productVariations?.table?.margin[key1][key2] ?? 0;
			}
			return marginValue;
		},
		getOutsourceCommissionVariation(key1, key2) {
			let oursourceCommision = 0;
			if (this.productVariations?.table?.outsource_commission) {
				oursourceCommision = this.productVariations?.table?.outsource_commission[key1][key2] ?? 0;
			}
			return oursourceCommision;
		},
		sanitizeHtml,
		addToWishlist() {
			this.isAddingWishlist = true;

			let productId = this.product._id;
			if (typeof this.product._id === 'object') {
				productId = this.product._id.$oid;
			}

			const type = this.isProductWishlisted ? 'remove' : 'add';

			const params = {
				product_id: productId,
			};

			const callback = (response) => {
				this.isAddingWishlist = false;
				const message = response.message || 'Success';
				this.$notify({
					group: 'app',
					title: 'Wishlist',
					text: message,
					type: 'success',
				});

				const product = {
					_id: productId,
				};

				if (type === 'add') {
					this.appendWishlistAdded(product);
				} else {
					this.removeWishlistAdded(product);
				}
			};

			const errorCallback = (e) => {
				this.isAddingWishlist = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					title: 'Wishlist',
					text: message,
					type: 'error',
				});
			};

			if (type === 'add') {
				wishlistApi.addWishlist(params, callback, errorCallback);
			} else {
				wishlistApi.removeWishlist(productId, callback, errorCallback);
			}
		},
		getVariableCommisionValue,
		filterById(array, id) {
			return array.filter(item => item.id === id);
		},
		isVariationEnabled(secondVariationName, firstVariationName) {
			let variantName = firstVariationName;
			if (this.productVariations.table.type !== 'single') {
				variantName = `${firstVariationName}||${secondVariationName}`;
			}
			const selectedVariant = this.productVariations?.prices?.find(variant => variant?.name === variantName);

			if (typeof selectedVariant?.enabled !== 'undefined' && !selectedVariant?.enabled) {
				return false;
			}

			return true;
		},
		isAllColumnNull(firstVariationName) {
			const itemCounter = Object.keys(this.tableData).reduce((total, variant) => (this.tableData[variant][firstVariationName] !== undefined ? total + 1 : total), 0);
			const nullCounter = Object.keys(this.tableData).reduce((total, variant) => (this.tableData[variant][firstVariationName] === null ? total + 1 : total), 0);

			return nullCounter === itemCounter;
		},
		isAllDataNull(firstVariationName) {
			const itemCounter = Object.keys(this.tableData).reduce((total, variant) => (this.tableData[variant][firstVariationName] !== undefined ? total + 1 : total), 0);
			const nullCounter = Object.keys(this.tableData).reduce((total, variant) => (this.tableData[variant][firstVariationName] === null ? total + 1 : total), 0);

			return nullCounter === itemCounter;
		},
		isAllRowNull(secondVariationName) {
			const itemCounter = Object.keys(this.tableData[secondVariationName]).length;
			const nullCounter = Object.values(this.tableData[secondVariationName]).filter(value => value === null).length;

			return nullCounter === itemCounter;
		},
		checkIfProductPrivate() {
			if (this.product?.visibility === 'private') {
				const productId = this.product?._id?.$oid ?? this.product?._id;
				this.checkProductPrivate(productId);
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isOoLoggedIn: 'isOoLoggedIn',
			isSupplier: 'isSupplier',
			productAdded: 'homepage/productAdded',
			wishlistAdded: 'wishlist/wishlistAdded',
			isAdmin: 'isAdmin',
		}),
		getBasePriceRegular() {
			const pricePlusCommission = getProductPricePlusCommission(this.product);
			return this.user ? formatMoney(pricePlusCommission) : elipsisPrice(pricePlusCommission);
		},
		getIndexOfVideo() {
			return this.product.pictures.length + 1;
		},
		dropshipFinalPrice() {
			return formatMoney(getDropshipFinalPrice(this.product, [], 1, true, false));
		},
		weightSimple() {
			return this.product?.weight;
		},
		isOfficialSeller() {
			return isHasFeature(this.user, 'official_seller');
		},
		isProductAdded() {
			return this.productAdded.findIndex(myid => myid.source_id === this.product._id.$oid) !== -1;
		},
		isProductWishlisted() {
			return this.wishlistAdded.findIndex(wishlistedProduct => wishlistedProduct._id === this.product._id.$oid) !== -1;
		},
		isProductPrivate() {
			// if (this.user?.role !== 'owner') {
			// 	return false;
			// }
			// return !!duplicateVar(isPrivate(this.product, this.user)); // duplicateVar to avoid reactivity, convert to boolean
			return this.isHidden;
		},
		isDisabled() {
			return this.isProductAdded || this.isProductPrivate;
		},
		setBreadcrumb() {
			const category = this.product ? this.product.category.category : null;
			const categorySlug = this.product ? this.product.category.category_slug : null;

			if (this.isAdmin) {
				return [
					{
						title: 'Products',
						url: '/admin/products',
					}, {
						title: this.product.name,
						url: `/admin/products/${this.product.slug}`,
					},
				];
			}
			return [
				{
					title: 'Home',
					url: '/',
				}, {
					title: category,
					url: `/search?c=${categorySlug}`,
				},
			];
		},
		isHasPage() {
			return this.user && this.product.pages !== undefined && this.product.pages.length > 0;
		},
		isShowMarketingKit() {
			return this.user && this.product?.marketing_kit?.visible && this.product?.marketing_kit !== undefined && !Array.isArray(this.product?.marketing_kit);
		},
		isShowMarketingKits() {
			return this.user && Array.isArray(this.product?.marketing_kit) && this.product?.marketing_kit?.length > 0;
		},
		dropshipFinalPriceRange() {
			const variations = getDropshipVariationFinalPrice(this.product, this.isOfficialSeller, !this.isOfficialSeller, false);
			let firstPrice = null;
			let secondPrice = null;
			(variations.prices).forEach((element) => {
				if (firstPrice == null) {
					firstPrice = element.price;
				} else if (firstPrice > element.price) {
					firstPrice = element.price;
				}
				if (secondPrice == null) {
					secondPrice = element.price;
				} else if (secondPrice < element.price) {
					secondPrice = element.price;
				}
			});

			const price = firstPrice !== secondPrice ? `${formatMoney(firstPrice)} - ${formatMoney(secondPrice)}` : formatMoney(firstPrice);

			return price;
		},
		weightVariable() {
			const variations = getDropshipVariationFinalPrice(this.product, this.isOfficialSeller, !this.isOfficialSeller);
			let minWeight = null;
			let maxWeight = null;
			(variations.prices).forEach((element) => {
				if (minWeight == null) {
					minWeight = element.weight;
				} else if (minWeight > element.weight) {
					minWeight = element.weight;
				}
				if (maxWeight == null) {
					maxWeight = element.weight;
				} else if (maxWeight < element.weight) {
					maxWeight = element.weight;
				}
			});

			const weight = minWeight !== maxWeight ? `${minWeight} - ${maxWeight}` : minWeight;

			return weight;
		},
		basePriceRange() {
			const variations = getDropshipVariationFinalPrice(this.product, this.isOfficialSeller, false);
			let firstPrice = null;
			let secondPrice = null;
			(variations.prices).forEach((element) => {
				if (firstPrice == null) {
					firstPrice = element.price;
				} else if (firstPrice > element.price) {
					firstPrice = element.price;
				}
				if (secondPrice == null) {
					secondPrice = element.price;
				} else if (secondPrice < element.price) {
					secondPrice = element.price;
				}
			});

			const formattedFirstPrice = !this.user ? elipsisPrice(firstPrice) : formatMoney(firstPrice);
			const formattedSecondPrice = !this.user ? elipsisPrice(secondPrice) : formatMoney(secondPrice);

			const price = firstPrice !== secondPrice ? `${formattedFirstPrice} - ${formattedSecondPrice}` : formattedFirstPrice;

			return price;
		},
		scrollAreaMaxHeight() {
			const scrollArea = this.elementHeight.photoElement - this.elementHeight.productTitle - this.elementHeight.productAggregate - this.elementHeight.pricing - this.elementHeight.nav - this.elementHeight.padding - this.elementHeight.margin;
			return `${scrollArea}px`;
		},
		toggleDescriptionLabel() {
			return this.isDescriptionExpanded ? 'Lihat Lebih Sedikit' : 'Lihat Selengkapnya';
		},
		originalPrice() {
			const price = getSimpleProductOriginalPrice(this.product);
			return this.user ? formatMoney(price) : elipsisPrice(price);
		},
		originalPriceRange() {
			const variations = getDropshipVariationFinalPrice(this.product, this.isOfficialSeller, false, false);
			let minPrice = null;
			let maxPrice = null;
			const variationPrices = variations?.prices ?? [];

			variationPrices.forEach((variation) => {
				const price = variation?.price ?? 0;

				if (minPrice === null || price < minPrice) {
					minPrice = price;
				}
				if (maxPrice === null || price > maxPrice) {
					maxPrice = price;
				}
			});

			const formattedMinPrice = !this.user ? elipsisPrice(minPrice) : formatMoney(minPrice);
			const formattedMaxPrice = !this.user ? elipsisPrice(maxPrice) : formatMoney(maxPrice);

			return minPrice !== maxPrice ? `${formattedMinPrice} - ${formattedMaxPrice}` : formattedMinPrice;
		},
		originalBuyPrice() {
			return this.product.type === 'variable' ? this.originalPriceRange : this.originalPrice;
		},
		hasSalePrice() {
			const originalPrice = this.originalBuyPrice;
			const salePrice = this.buyPrice;

			const isDifferent = originalPrice !== salePrice;

			if (!this.user) {
				return true;
			}

			return isDifferent;
		},
		simplePercentOff() {
			const pricePlusCommission = getProductPricePlusCommission(this.product);
			const originalPrice = getSimpleProductOriginalPrice(this.product);
			return this.user ? calculateDiscount(pricePlusCommission, originalPrice) : 'XX%';
		},
		variablePercentOff() {
			const variationsSalePrices = getDropshipVariationFinalPrice(this.product, this.isOfficialSeller, false);
			const variationsOriginalPrices = getDropshipVariationFinalPrice(this.product, this.isOfficialSeller, false, false);

			let highestPercentOff = 0;

			const salePrices = variationsSalePrices?.prices ?? [];
			const originalPrices = variationsOriginalPrices?.prices ?? [];

			salePrices.forEach((variant, idx) => {
				const isVariantEnabled = variant?.enabled ?? true;
				if (!isVariantEnabled) return;

				const salePrice = variant?.price ?? 0;
				const originalPrice = originalPrices[idx]?.price ?? 0;

				const percentOff = calculateDiscount(salePrice, originalPrice, false);

				if (percentOff > highestPercentOff) {
					highestPercentOff = percentOff;
				}
			});

			return this.user ? `${highestPercentOff}%` : 'XX%';
		},
		percentOff() {
			return this.product.type === 'variable' ? this.variablePercentOff : this.simplePercentOff;
		},
		isDetailTabActive() {
			return this.activeTab === 'detailTab';
		},
		productVariations() {
			return this.product?.variations ?? [];
		},
		buyPrice() {
			return this.product.type === 'variable' ? this.basePriceRange : this.getBasePriceRegular;
		},
		sellPrice() {
			return this.product.type === 'variable' ? this.dropshipFinalPriceRange : this.dropshipFinalPrice;
		},
		weight() {
			return this.product.type === 'variable' ? this.weightVariable : this.weightSimple;
		},
		isCODEnabled() {
			return this.product?.payments.findIndex(payment => payment === 'cod') !== -1;
		},
		isLpEnabled() {
			return this.product?.pages?.length > 0 ?? false;
		},
		isMarketingKitEnabled() {
			return this.product?.marketing_kit?.visible ?? false;
		},
		supplierCode() {
			return this.product.user?.code;
		},
		supplierOrigin() {
			return this.getShippingCityProvince(this.product.user?.store?.shipping?.origin);
		},
		favoriteIconStyle() {
			return {
				visibility: this.isAddingWishlist ? 'hidden' : 'visible',
				fontSize: '16px',
			};
		},
		tableData() {
			const data = duplicateVar(this.productVariations?.table?.data);

			return data;
		},
		storeAvailability() {
			return this.product?.user?.store_availability ?? true;
		},
	},
	watch: {
		'$route.params': {
			handler() {
				const newProductSlug = this.$route.params?.slug;
				this.getProductBySlug(newProductSlug);
				if (this.isOoLoggedIn) {
					this.getDropshipProductAdded();
					this.getProductWishlistAdded();
				}
			},
		},
		user() {
			this.getProductBySlug(this.productSlug);
			this.getProductWishlistAdded();
			if (this.isSupplier) {
				this.$router.push('/');
			}

			this.checkIfProductPrivate();
		},
		product() {
			this.checkIfProductPrivate();
		},
	},
	mounted() {
		this.assignScrollAreaSize();
	},
	created() {
		this.getProductBySlug(this.productSlug);
		if (this.isOoLoggedIn) {
			this.getDropshipProductAdded();
			this.getProductWishlistAdded();
		}
	},
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/modules/_variables.scss";

::v-deep .slick-arrow:before {
	color: #2f3241;
	opacity: 1;
}

.slick-current .img-thumb {
	border: 2px solid $color__primary;
}

img.img-second {
	width: 100%;
	height: 300px;
	object-fit: contain;
}

.img-thumb-box {
	padding: 3px;
	cursor: pointer;
}

img.img-thumb {
	width: 100%;
	padding: 0px;
	border-radius: 8px;
	// max-height: 100px;
	aspect-ratio: 1 / 1;
	object-fit: contain;
	background-color: #f3f3f3;
	border: 1px solid #dfdfdf;
}

img.img-main {
	width: 100%;
	border-radius: 8px;
	// max-height: 500px;
	background-color: #f3f3f3;
	aspect-ratio: 1 / 1;
	object-fit: contain;
	border: 1px solid #f0f0f0;
}

.details {
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-ms-flex-direction: column;
	flex-direction: column;
}

.product-title,
.price,
.benefit-for-seller h5,
.selling-price h4 {
	/* text-transform: UPPERCASE; */
	font-weight: bold;
}

.product-title {
	margin-bottom: 2px;
}

.price span {
	color: #ff9f1a;
	margin-bottom: 2px;
}
.price {
	margin-bottom: 0;
}

.selling-price h4 {
	color: #ff9f1a;
}

.first-aggregate {
	list-style: none;
}

.product-dropship-modal .modal-container {
	border-radius: 16px;
}
.product-dropship-modal .modal-footer {
	background-color: transparent;
}
.product-dropship-modal .modal-header {
	background-color: transparent;
	border-bottom: none;
	padding: 2px 5px;
}

.benefit-icon > .material-icons {
	font-size: 2rem;
	color: $color_ostock_primary_900;
}
.benefit-name, .product-aggregate {
	font-size: 12px;
}

.nav-tabs .nav-link {
	background-color: transparent;
	border-top-left-radius: unset;
	border-top-right-radius: unset;
	border-color: unset;
    border-right-color: unset;
	border: unset;
}

.nav-tabs .nav-link.active {
	color: $color_ostock_primary;
	border-bottom: 2px solid $color_ostock_primary;
}

.card-user-price {
	border: 1px solid rgb(0 0 0 / 8%);
	border-radius: 0.5rem;
	.card-footer button {
		border-top-left-radius: 0;
		border-top-right-radius: 0;
	}
}

.not-found {
	h3 {
		color: black;
	}
}

.img-center {
	display: block;
	margin-left: auto;
	margin-right: auto;
    width: 30px;
    margin-bottom: 8px;
}

.variant-price {
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
	background-color: $color_ostock_primary;
	color: #fff;
	padding: 0.1rem;
	padding-bottom: 0.1rem;
}

@media only screen and (max-width: 991px) {
	.product-aggregate li {
		list-style: none;
	}
}

.price-color {
	color: #ff9f1a;
}

.price-info {
	color: #656565;
}

.price-mobile {
	font-size: 12px;
	display: none;
}

@media only screen and (max-width: 600px) {
	.price-mobile {
		display: block !important;
	}
}

.product-variations {
	.desc {
		label, .capital-price, .selling-price {
			font-size: 12px;
		}
	}
}

.variant-table {
	font-size: 12px;
	thead, tbody tr .multiple-variant {
		font-size: 14px;
	}
}

.variant-table.table-striped tbody tr:nth-of-type(odd) {
    background-color: #f2f9ff;
}

.variant-table.table thead th {
    border-bottom: 0 !important;
}

.spacer {
	margin-bottom: 3rem;
	@media screen and (max-width: 540px) {
		margin-bottom: 20px;
	}
}

::-webkit-scrollbar {
    background-color: #f5f5f5;
    border-radius: 10px;
    width: 7px;
    height: 2px;
}
::-webkit-scrollbar-thumb {
    background-color: #656565;
    border-radius: 10px;
}

.description-toggle {
	font-weight: bold;
	cursor: pointer;
}
.fade-enter-active, .fade-leave-active {
	transition: opacity 0.15s linear;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}

.blur {
	border-radius: 5px;
	filter: blur(3px);
}

.share-btn {
	border-radius: 8px;
	border: 1px solid  #676C78;
	background:  rgba(255, 255, 255, 0.00);
	color: #676C78;
	font-size: 14px;
}

.ask-btn {
	border-radius: 8px;
	border: 1px solid red;
	color: red;
	font-size: 14px;
}

.card {
	border-radius: 8px;
	border: 1px solid #D0D5DD;
	background: linear-gradient(268deg, rgba(0, 109, 199, 0.40) -12.7%, rgba(230, 240, 249, 0.26) 100%);
}

.title-link {
	color:#1B1E24;
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: 24px;
}

.share-link {
	color:#676C78;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px;
}

.share-info {
	color: #414756;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
}
.icon {
	width: 30px;
	height: 30px;
	padding: 2px;
	border-radius: 8px;
	border: 1px solid #D0D5DD;
}

.sale-price {
	text-decoration: line-through;
	color: #a7a7a7;
	font-size: 16px;
}

.percent-off {
	background-color: #ffd5de;
	color: #fd4860;
	font-size: 12px;
}
</style>
